import { SentryCapture } from '@zz-common/sentry'

export default (Vue) => {
  try {
    Vue.component('ErrorBoundary', {
      data: () => ({ error: null }),
      errorCaptured(err, vm, info) {
        console.error('报错了吗', err, info)
        this.error = `${err.stack}\n\nfound in ${info} of component`
        SentryCapture(this.error, 'error')
        return false
      },
      render(h) {
        if (this.error) {
          return null
        }
        return (this.$slots.default || [null])[0] || null
      }
    })
  } catch (err) {
    console.log(err)
    SentryCapture(err, 'error')
  }
}
